module.exports = __webpack_public_path__ + "media/images/partner-2-a4bc26f270b719a7e222ca44a6e596cd.png";